import type { ReactElement } from 'react'
import {
  smsInfoBar,
  smsInfoBarItem
} from '~/components/Scopes/Actions/Actions.css'

type SmsInfoBarSendingInfo = {
  smsMax: number
  smsRemaining: number | null
  stopSMSLength: number
  singleSMSLength: number
  multiSMSLength: number
}

type SmsInfoBarProps = {
  content: string
  sendingInfo: SmsInfoBarSendingInfo
  onlyRemaining?: boolean
}

const getReadableLength = (html: string): number => {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent?.length ?? 0
}

export const SmsInfoBar = ({
  content,
  sendingInfo,
  onlyRemaining = false
}: SmsInfoBarProps): ReactElement => {
  const length = getReadableLength(content)
  let maxLength = sendingInfo.singleSMSLength - sendingInfo.stopSMSLength
  let smsCount = 1
  if (sendingInfo.smsMax > 1 && length > maxLength) {
    smsCount = Math.ceil(
      (length + sendingInfo.stopSMSLength) / sendingInfo.multiSMSLength
    )
    maxLength =
      smsCount * sendingInfo.multiSMSLength - sendingInfo.stopSMSLength
  }

  return (
    <div className={smsInfoBar}>
      <div>
        {!onlyRemaining && (
          <>
            <span className={smsInfoBarItem}>
              <strong>
                {length} / {maxLength}
              </strong>{' '}
              caractères + (STOP SMS).
            </span>{' '}
            {(sendingInfo?.smsMax ?? 2) > 1 && (
              <span className={smsInfoBarItem}>
                SMS décomptés :{' '}
                <strong>
                  {smsCount}/{sendingInfo.smsMax}
                </strong>
              </span>
            )}
          </>
        )}
      </div>
      {sendingInfo.smsRemaining !== null && (
        <div className={smsInfoBarItem}>
          Solde SMS : <strong>{sendingInfo.smsRemaining}</strong>
        </div>
      )}
    </div>
  )
}
